var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcoPdfFile = function SvgIcoPdfFile(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 11 12",
    style: {
      enableBackground: "new 0 0 11 12"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,12H1v-1h9V3.5H7.5V1H2v3.5H1V0h8l2,2V12z M8.5,2.5l1.5,0L8.5,1V2.5z M7.8,9.5h-1v-4h2.5v1H7.8v0.8h1v1h-1V9.5z  M4.6,9.5H3.2v-4h1.4c0.6,0,1.6,0.3,1.6,2S5.2,9.5,4.6,9.5z M4.2,8.5h0.4c0.3,0,0.6,0,0.6-1s-0.4-1-0.6-1H4.2V8.5z M1.1,9.5H0v-4 h1.2c1,0,1.6,0.6,1.6,1.5S2.3,8.5,1.2,8.5H1.1V9.5z M1,7.5h0.2c0.6,0,0.6-0.2,0.6-0.5s0-0.5-0.6-0.5H1V7.5z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoPdfFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_pdf_file.58ecae66.svg";
export { ForwardRef as ReactComponent };